import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6639f163"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mb-3 has-text-grey is-block" }, "Действия", -1))
const _hoisted_2 = {
  key: 0,
  class: "control"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon has-text-success" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle is-success" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Подтвердить", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "control"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon has-text-success" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Отправить на модерацию", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "control"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon has-text-danger" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban" })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Заблокировать", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 3,
  class: "control"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon has-text-warning" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban" })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Разблокировать", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 4,
  class: "control"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon has-text-info" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Наблюдать", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 5,
  class: "control"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon has-text-info" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" })
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Перестать наблюдать", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = {
  key: 6,
  class: "control"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon has-text-warning" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-restore" })
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Не спам", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon has-text-danger" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" })
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Спам", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["box", {'busy': _ctx.item.isEntityLoading}])
  }, [
    _hoisted_1,
    (!_ctx.item.entity.passport.is_passport_verified)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "button is-justify-content-flex-start is-white is-medium",
            style: {"width":"100%"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.verify && _ctx.verify(...args)))
          }, _hoisted_5)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "button is-justify-content-flex-start is-white is-medium",
            style: {"width":"100%"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.remoderate && _ctx.remoderate(...args)))
          }, _hoisted_9)
        ])),
    (!_ctx.item.entity.general.is_banned)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "button is-justify-content-flex-start is-white is-medium",
            style: {"width":"100%"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ban && _ctx.ban(...args)))
          }, _hoisted_13)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "button is-justify-content-flex-start is-white is-medium",
            style: {"width":"100%"},
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.ban && _ctx.ban(...args)))
          }, _hoisted_17)
        ])),
    (!_ctx.item.entity.general.is_watch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "button is-justify-content-flex-start is-white is-medium",
            style: {"width":"100%"},
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.watching && _ctx.watching(...args)))
          }, _hoisted_21)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("button", {
            class: "button is-justify-content-flex-start is-white is-medium",
            style: {"width":"100%"},
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.watching && _ctx.watching(...args)))
          }, _hoisted_25)
        ])),
    (!_ctx.item.entity.passport.is_passport_verified)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("button", {
            class: "button is-justify-content-flex-start is-white is-medium",
            style: {"width":"100%"},
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.spam && _ctx.spam(...args)))
          }, [
            (!_ctx.item.entity.passport.is_passport_verified)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  (_ctx.item.entity.passport.is_excluded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
                    : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}